import { SvgProps } from "../../types";

export default function CalendarDaysIcon({ className }: SvgProps) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M5.11108 2.44379V0.666016"
                stroke="#576A81"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.8889 2.44379V0.666016"
                stroke="#576A81"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.2222 2.44336H3.77778C2.79594 2.44336 2 3.2393 2 4.22114V11.7767C2 12.7585 2.79594 13.5545 3.77778 13.5545H12.2222C13.2041 13.5545 14 12.7585 14 11.7767V4.22114C14 3.2393 13.2041 2.44336 12.2222 2.44336Z"
                stroke="#576A81"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2 5.55469H14"
                stroke="#576A81"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.99997 7.33203C7.5102 7.33203 7.11108 7.73114 7.11108 8.22092C7.11108 8.7107 7.5102 9.10981 7.99997 9.10981C8.48975 9.10981 8.88886 8.7107 8.88886 8.22092C8.88886 7.73114 8.48975 7.33203 7.99997 7.33203Z"
                fill="#576A81"
            />
            <path
                d="M11.1115 9.10981C11.6013 9.10981 12.0004 8.7107 12.0004 8.22092C12.0004 7.73114 11.6013 7.33203 11.1115 7.33203C10.6218 7.33203 10.2227 7.73114 10.2227 8.22092C10.2227 8.7107 10.6218 9.10981 11.1115 9.10981Z"
                fill="#576A81"
            />
            <path
                d="M7.99997 10C7.5102 10 7.11108 10.3991 7.11108 10.8889C7.11108 11.3787 7.5102 11.7778 7.99997 11.7778C8.48975 11.7778 8.88886 11.3787 8.88886 10.8889C8.88886 10.3991 8.48975 10 7.99997 10Z"
                fill="#576A81"
            />
            <path
                d="M4.88889 10C4.39911 10 4 10.3991 4 10.8889C4 11.3787 4.39911 11.7778 4.88889 11.7778C5.37867 11.7778 5.77778 11.3787 5.77778 10.8889C5.77778 10.3991 5.37867 10 4.88889 10Z"
                fill="#576A81"
            />
            <path
                d="M11.1115 10C10.6218 10 10.2227 10.3991 10.2227 10.8889C10.2227 11.3787 10.6218 11.7778 11.1115 11.7778C11.6013 11.7778 12.0004 11.3787 12.0004 10.8889C12.0004 10.3991 11.6013 10 11.1115 10Z"
                fill="#576A81"
            />
        </svg>
    );
}
